<template>
    <div class="contacts-page">
        <div class="container">
            <div class="page-title">
                <h1>{{ contactsPage.page_title }}</h1>
            </div>
            <div class="contacts-page-head">
                <div class="contacts-form-links">
                    <button class="btn-form btn-complement" @click="openContactsFormModal('grat', 'contacts-page', 'Блок навигации')">
                        <span>{{contactsPage.btn_grat}}</span>
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </button>
                    <button class="btn-form btn-call" @click="openContactsFormModal('call', 'contacts-page', 'Блок навигации')">
                        <span>{{contactsPage.btn_call}}</span>
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </button>
                </div>
                <div class="page-title-navigation">
                    <ul>
                        <li v-for="item in contactsPage.page_nav"><router-link :to="item.link == '/contacts' ? '/contacts' : '/contacts' + item.link">{{ item.name }}</router-link></li>
                    </ul>
                </div>
            </div>
            <div class="contacts-content-container"><router-view></router-view></div>
        </div>
        <formPage></formPage>
        <!-- @closed="videoModalClosed"  -->
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import formPage from '@/components/forms/form-page.vue'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'contacts--page',
        components: {
            formPage,
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            contactsPage: 'loadContactsPage',
        }),
        methods: {
            openContactsFormModal(param, page, block) {
                this.$store.commit('formGlobalParam_set', param);
                this.$store.commit('formGlobalDataModal_set', {'page' : page, 'block' : block});
                this.$store.commit('formModalContainerOpen');
            },
        },
        beforeRouteEnter (to, from, next) {
            // store.dispatch('getNewsItems');
            // store.dispatch('getIndexPageData');
            // store.dispatch('getSalesItems');
            if (store.state.contactsPage != null) {
                next();
                // next(vm => {
                //     // vm.$store.commit('removePageLoaderImg');
                //     setTimeout(() => {
                //         vm.$parent.$refs.topProgress.done();
                //     }, 300);
                // });
            } else {
                store.dispatch('getContactsPageData').then((response) => {
                    if (response) {
                        next();
                        // next(vm => {
                        //     // vm.$store.commit('removePageLoaderImg');
                        //     setTimeout(() => {
                        //         vm.$parent.$refs.topProgress.done();
                        //     }, 300);
                        // });
                    } else {
                        next(false);
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'contacts';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/contacts-page/contacts-page.scss';
    @import '@/styles/components/contacts-page/respond/contacts-page-respond.scss';
</style>